import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  Button,
  Table,
  Input,
} from "reactstrap";

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import Autocomplete from "../controls/_Autocomplete";
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import ButtonExt from "../controls/ButtonExt"
import ButtonToggle from "../controls/_ButtonToggle"
import * as common from "../../lib/common"
import { BtnPermissions } from "../../lib/BtnPermissions"
import * as constants from "../Order/constants"
import marketingOrderConstants from "./constants"
import NumberCtr from "./_NumberCtr"
import UiEditable from "./_UiEditable"
import AppConfig from "../../config/app"

class OrderControls extends Component {

  render() {
    const {
      requesting,
      warnings,
      messages,
      errors,
      orderInfor,
      mode,
      isShowCKPercent,
    } = this.props

    const {added_customers} = orderInfor
    // kiểm tra xem đang ở mode edit hay không
    const isEditMode = mode === marketingOrderConstants.MODE.IN_EDIT
    // kiểm tra xem đang có quyền chỉnh sửa hay không
    const isEditable = !isEditMode || (orderInfor && orderInfor.is_editable)
    // kiểm tra xem đã có thuốc nào hay chưa
    const isHasItems = this.props.items && this.props.items.length > 0
    // bo chiet khau de tich diem hay khong
    const isBoCk = orderInfor && orderInfor[constants.FormFiels.BoChietKhau]
    // Kiểm tra xem đơn đang gửi thì không cho sửa
    const itemUpdatabled = orderInfor && orderInfor.c_eit

    const getItems = e => {
      const items = this.props.items || [];
      return items.map((item, idx) => {
        const soLuong = item.so_luong || 0
        const giaBan = item.gia_ban || 0
        const chietKhau = item.chiet_khau || 0
        const thanhTien = item.thanh_tien || 0

        return [
          (
            <tr className="hide-in-mobile" key={idx}>
              <td scope="col" className="text-justify">
                <Button title={"Kích để sửa thông tin"} className={`btn btn-link border-0 pl-0`} onClick={e => this.props.handleEditItem(item)}>
                  {`${item.sku}/ ${item.ten}`}
                </Button>
              </td>
              <td scope="col" className="text-justify">
                {item.dvt}
              </td>
              <td scope="col" className="text-right">
                {soLuong.toLocaleString()}
              </td>
              <td scope="col" className="text-right">
                {giaBan.toLocaleString()}
              </td>
              <td scope="col" className={`text-right ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                {item.diem}
              </td>
              <td scope="col" className={`text-right ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                <UiEditable
                  name={`ck${idx}`}
                  valueStr={chietKhau.toLocaleString()}
                  value={chietKhau}
                  defaultValue={0}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={0}
                  type="tel"
                  allowEmptyFormatting={true}
                  allowEditable={(!isEditMode || itemUpdatabled) && item.is_km != 1}
                  className={"form-control text-right"}
                  classNameWarper={"ckEditCtl"}
                  onValueChange={(e) => this.props.handleCkChange(item, e)}
                />
              </td>
              <td scope="col" className="text-right">
                {thanhTien.toLocaleString()}
              </td>
              <td scope="col" className="text-justify">
                {itemUpdatabled && (
                  <Button size="sm" className={`btn btn-danger`} onClick={e => this.props.handleRemoveItem(item)}>
                    <i className="fa fa-trash-o"></i>
                  </Button>
                )}
              </td>
            </tr>
          ),
          (
            <tr className="show-in-mobile" key={`${idx}-0`}>
              <td scope="col" colSpan="6" className="text-justify border-bottom">
                <Button size="sm" className={`btn btn-danger`} onClick={e => this.props.handleRemoveItem(item)}>
                  <i className="fa fa-trash-o"></i>
                </Button>
                <Button title={"Kích để sửa thông tin"} className={`btn btn-link border-0 pl-0`} onClick={e => this.props.handleEditItem(item)}>
                  {`${item.sku}/ ${item.ten}`}
                </Button>
              </td>
            </tr>
          ),
          (
            <tr className="show-in-mobile" key={`${idx}-1`}>
              <td scope="col" className="text-justify border-bottom">
                {item.dvt}
              </td>
              <td scope="col" className="text-right border-bottom">
                {soLuong.toLocaleString()}
              </td>
              <td scope="col" className="text-right border-bottom">
                {giaBan.toLocaleString()}
              </td>
              <td scope="col" className={`text-right border-bottom ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                {item.diem}
              </td>
              <td scope="col" className={`text-right border-bottom ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                <UiEditable
                  name={`ck${idx}`}
                  valueStr={chietKhau.toLocaleString()}
                  value={chietKhau}
                  defaultValue={0}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={0}
                  type="tel"
                  allowEmptyFormatting={true}
                  allowEditable={(!isEditMode || itemUpdatabled) && item.is_km != 1}
                  className={"form-control text-right"}
                  classNameWarper={"ckEditCtl"}
                  onValueChange={(e) => this.props.handleCkChange(item, e)}
                />
              </td>
              <td scope="col" className="text-right border-bottom">
                {thanhTien.toLocaleString()}
              </td>
            </tr>
          )
        ]
      });
    }

    const mapToCustomers = (datas) => {
      return (datas || []).map((item) => {
        let label = item.Ten
        if (item.Ma && item.Ma !== '') {
          label += `/${item.Ma}`
        }

        return {
          label: label,
          value: item.Id,
          dienThoai: item.DienThoai,
          diaChi: item.DiaChi,
          ref: item,
        }
      })
    }

    const mapToProducts = (datas) => {
      return (datas || []).map((item) => {
        const label = item.Sku ? `${item.Sku}/ ${item.Ten}` : item.Ten
        return {
          label: label,
          value: item.Id,
          dvt: item.DvtTen,
          quantity: item.TonKho,
        }
      })
    }

    const getListKhos = (items) => {
      return items.map((item, idx) => {
        return (
          <option key={idx} label={item.Tem} value={item.Id}>{item.Ten}</option>
        )
      })
    }

    const sumQuantity = () => {
      const items = this.props.items || [];
      return common.sum(items, "so_luong").toLocaleString()
    }
    const sumRefun = (isShowSumValue) => {
      if (!isShowSumValue) {
        return ""
      }
      const items = this.props.items || [];
      return common.sum(items, "chiet_khau").toLocaleString()
    }
    const sumFee = () => {
      const items = this.props.items || [];
      return common.sum(items, "thanh_tien").toLocaleString()
    }
    const sumScore = () => {
      const items = this.props.items || [];
      return common.sum(items, "diem").toLocaleString()
    }
    const renderListCustomer = (addedCustomers) => {
      if (!addedCustomers || addedCustomers.length === 0) {
        return null
      }
      const items = addedCustomers.map((item, index) => {
        return (
          <li className="item list-group-item p-1" key={index}>
            <div>
              {item.IsRemovable && (
                <i className="btn btn-danger btn-sm fa fa-trash mr-1 btn-remove" onClick={e => this.props.onRemoveCustomer(item)}></i>
              )}
              {item.Ten}/ <span className="text-muted">{item.Ma}</span>
            </div>
            <span className={"item_unit text-muted pl-1"}>{item.DiaChi}</span>
          </li>
        )
      })
      return items
    }
    return (
      <BlockUi tag="div" blocking={requesting}>
        <div className="col-sm-7 col-md-8 pull-left">
          <Card>
            <CardBody className="p-1">
              <div className="col-sm-12">
                {isEditMode && !isEditable && (
                  <div className="col-sm-12 mb-2 pull-left">{`Đơn hàng đang được chỉnh sửa bởi ${orderInfor.lock_by}`}</div>
                )}
                <div className="col-sm-7 col-7 mb-2 pull-left">
                  {!isEditMode && !isHasItems && (
                    <CheckboxTreeList
                      placeholder={`--Chọn nhân viên--`}
                      nodes={this.props.users}
                      isMultiChoice={false}
                      checked={this.props.usersChecked}
                      onHandleClick={this.props.onHandleClick}
                      onHandleRemove={this.props.onHandleRemove}
                      onChoice={this.props.onHandleChoice}
                      tabIndex={1}
                    />
                  )}
                  {(isEditMode || isHasItems) && (
                    <span>Nhân viên: <b>{orderInfor.ten_nhan_vien}</b></span>
                  )}
                </div>
                <div className="col-sm-5 col-5 mb-2 pull-left">
                  {!isEditMode && !isHasItems && (
                    <select tabIndex={2} disabled={isHasItems} className="form-control" value={orderInfor.kho_xuat_id} onChange={e => this.props.handleKhoChange(e)}>
                      <option value="">--Kho xuất--</option>
                      {getListKhos(this.props.khoXuats)}
                    </select>
                  )}
                  {(isEditMode || isHasItems) && (
                    <span>Kho: <b>{orderInfor.ten_kho}</b></span>
                  )}
                  
                </div>
                <div className="clearfix"></div>
                {(!isEditMode || itemUpdatabled) && (
                  <Fragment>
                    <div className="col sp-wrapper mb-2 pull-left">
                      <Autocomplete
                        name="thuoc"
                        placeholder="Tên/ mã hàng"
                        setFocus={false}
                        selectOnTab={true}
                        tabIndex={3}
                        formatOptionLabel={this.props.thuocFormatOptionLabel}
                        formatNoOptionLabel={this.props.thuocFormatNoOptionLabel}
                        handleClearClick={this.props.thuocHandleClearClick}
                        handleChange={this.props.thuocHandleChanged}
                        onSelection={this.props.productHandleSelectChange}
                        suggestions={mapToProducts(this.props.thuocs)}
                        onRef={(ctl) => this.props.setProductCtl(ctl)}
                      />
                    </div>
                    <div className="col quantity-wrapper mb-2 pull-left">
                      <NumberCtr
                        name={"quantity"}
                        value={this.props.quantity}
                        defaultValue={1}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        decimalScale={0}
                        type="tel"
                        tabIndex={4}
                        allowEmptyFormatting={true}
                        className={"form-control order-input-sl price"}
                        onClick={this.props.numberOnclick}
                        onValueChange={this.props.handleQuantityChange}
                        onKeyDown={this.props.handleQuantityKeyPress}
                        downClick={this.props.downQuantityClick}
                        upClick={this.props.upQuantityClick}
                      />
                    </div>
                    <div className="col km-wrapper mb-2 pull-left">
                      <ButtonToggle text={"KM"} handleChange={this.props.handleIsKMChange} isChecked={this.props.isKM} />
                    </div>
                    <div className="col add-item-wrapper mb-2 pull-left">
                      <Button tabIndex={5} className="btn_add_item" color="primary" disabled={!this.props.enabledAddItem} onClick={this.props.handleAddItem}>
                        <i className="fa fa-arrow-down mr-1"></i><span className="btn_add_item_text">Thêm</span></Button>
                    </div>
                  </Fragment>
                )}
                {isEditMode && !itemUpdatabled && (
                  <div className="col-sm-12 col-12 mb-2 pull-left">
                    <span>Chú ý: <b>Đơn đã gửi đi chỉ cho phép cập nhật nhà thuốc để gửi thêm</b></span>
                  </div>
                )}
                <div className="clearfix"></div>
              </div>
              <div className={"msg-add-item-warning mb-2 mt-2"}>
                <div className="col-sm-12">
                  {!!warnings.length && (
                    <Messages className={"msg-add-item-warning-content"} messages={warnings} />
                  )}
                </div>
              </div>
              <div className="col-sm-12 mb-2">
                <Table hover responsive className="table-outline table-sm mb-0">
                  <thead className="thead-default">
                    <tr className="hide-in-mobile">
                      <th scope="col" className="text-justify">
                        Tên thuốc
                      </th>
                      <th scope="col" className="text-justify">
                        ĐVT
                      </th>
                      <th scope="col" className="text-right">
                        Số lượng
                      </th>
                      <th scope="col" className="text-right">
                        Đơn gía
                      </th>
                      <th scope="col" className={`text-right ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        Điểm
                      </th>
                      <th scope="col" className={`text-right ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        C/khấu {isShowCKPercent ? "(%)" : ""}
                      </th>
                      <th scope="col" className="text-right">
                        Thành tiền
                      </th>
                      <th scope="col" className="text-right">
                        &nbsp;
                      </th>
                    </tr>
                    <tr className="show-in-mobile">
                      <th scope="col" colSpan="5" className="text-justify">
                        Tên
                      </th>
                    </tr>
                    <tr className="show-in-mobile">
                      <th scope="col" className="text-justify">
                        ĐVT
                      </th>
                      <th scope="col" className="text-right">
                        S/lượng
                      </th>
                      <th scope="col" className="text-right">
                        Đ/giá
                      </th>
                      <th scope="col" className={`text-right ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        Điểm
                      </th>
                      <th scope="col" className={`text-right ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        C/khấu {isShowCKPercent ? "(%)" : ""}
                      </th>
                      <th scope="col" className="text-right">
                        T/Tiền
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {getItems()}
                  </tbody>
                  <tfoot className="thead-default">
                    <tr className="hide-in-mobile">
                      <td colSpan="2" scope="col" className="text-right">
                        <span className="text-primary font-weight-bold">Tổng<label className="d-none"> cộng</label>: </span>
                      </td>
                      <td colSpan="1" scope="col" className="text-right font-weight-bold">
                        {sumQuantity()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        &nbsp;
                      </td>
                      <td scope="col" className={`text-right font-weight-bold ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        {sumScore()}
                      </td>
                      <td scope="col" className={`text-right font-weight-bold ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        {sumRefun()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        {sumFee()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        &nbsp;
                      </td>
                    </tr>
                    <tr className="show-in-mobile">
                      <td colSpan="1" scope="col" className="text-right">
                        <span className="text-primary font-weight-bold">Tổng<label className="d-none"> cộng</label>: </span>
                      </td>
                      <td colSpan="1" scope="col" className="text-right font-weight-bold">
                        {sumQuantity()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        &nbsp;
                      </td>
                      <td scope="col" className={`text-right font-weight-bold ${!isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        {sumScore()}
                      </td>
                      <td scope="col" className={`text-right font-weight-bold ${isBoCk ? "d-none fadeOut" : "fadeIn"}`}>
                        {sumRefun()}
                      </td>
                      <td scope="col" className="text-right font-weight-bold">
                        {sumFee()}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-sm-5 col-md-4 pull-left">
          <Card>
            <CardBody className="p-1">
              <div className="col-sm-12">
                <div className="col-sm-12 mb-1">
                  <Autocomplete
                    name="customer"
                    placeholder="Tên khách hàng, số điện thoại"
                    setFocus={false}
                    selectOnTab={true}
                    clearOnSelection={true}
                    tabIndex={6}
                    formatOptionLabel={this.props.formatOptionLabel}
                    formatNoOptionLabel={this.props.formatNoOptionLabel}
                    handleClearClick={this.props.onCustomerTextChanged}
                    handleChange={this.props.onCustomerTextChanged}
                    onSelection={this.props.onCustomerSelectChanged}
                    suggestions={mapToCustomers(this.props.customers)}
                    onRef={(ctl) => this.props.setCustomerCtl(ctl)}
                  />
                </div>
                <div className="col-sm-12 mt-2 mb-1">
                  <ul className="list-group order-lst-customer">
                    {renderListCustomer(added_customers)}
                  </ul>
                </div>
                {isEditMode && (
                  <div className="col-sm-12  mb-1">
                    <div className="input-group input-group-md display-table">
                      <div className="input-group-prepend  display-table-cell">
                        <span className="input-group-text" htmlFor="dateCreated">Ngày lập</span>
                      </div>
                      <div className={"form-control display-table-cell"}>
                        <span><b>{common.formatDateTime(orderInfor.ngay_lap, "DD-MM-YYYY")}</b></span>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-12 pull-left mb-1">
                  <label className="input-group-text text-danger mb-1" htmlFor="xuat_hoa_don">
                    <Input className="form-checkbox-append"
                      onChange={e => this.props.handleXuatHDCreated(e)}
                      aria-label="Small"
                      aria-describedby="inputGroup-sizing-sm"
                      type="checkbox" name="xuat_hoa_don"
                      id="xuat_hoa_don"
                      tabIndex={9}
                      checked={orderInfor.xuat_hoa_don || false} />
                    &nbsp;Xuất hóa đơn
                  </label>
                </div>
                <div className="mb-1">
                  <Input tabIndex={10} type="textarea" maxLength={250} name="tenKhachHang" placeholder="Ghi chú" value={orderInfor.ghi_chu || ''} onChange={e => this.props.handleNoteCreated(e)} />
                  <div className="clearfix"></div>
                </div>
              </div>
              <div>
                <div className="col-sm-12">
                  {!requesting && !!errors.length && (
                    <Errors message="Failure to signup due to:" errors={errors} />
                  )}
                  {!requesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </div>
              </div>
              <div>
                <div className="col-sm-12">
                  <div className="btn-group float-right btn-edit-group" role="group">
                    <Button tabIndex={11} className="btn btn-secondary mr-1 btn-xs-left" onClick={() => this.props.return2List()}>
                      <i className="fa fa-long-arrow-left"></i><span className="d-sm-inline">&nbsp;Quay về</span>
                    </Button>
                    {isEditable && (
                      <ButtonExt tabIndex={12} isDisabled={(requesting || !isHasItems)} size="md" btnClass="pull-right btn-success btn-save" btnClick={this.props.save} 
                        iconClass="fa-save" displayText="Lưu" permission={BtnPermissions.DonHang.SAVE_ORDER}/>
                    )}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </BlockUi>
    )
  }
}

export default OrderControls;



// WEBPACK FOOTER //
// ./src/views/MarketingOrder/OrderControls.js